import { Helmet } from 'react-helmet-async';
import { Box, Typography } from '@mui/material';

export default function ProductsPage() {
  return (
    <>
      <Helmet>
        <title>華辰ERPS系統</title>
      </Helmet>

      <Box
        sx={{
          width: '100vw',
          height: '100vh',
          minHeight: '100dvh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',   // 靠左
          background: 'linear-gradient(135deg, #e3e9ff 0%, #f9faff 100%)',
          pl: '15vw', // 推到畫面1/2左右 (15vw~20vw看字長度調整)
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontWeight: 'bold',
            color: '#223177',
            letterSpacing: 3,
            textAlign: 'left',
            fontSize: { xs: '2.5rem', md: '4.5rem', lg: '5rem' }, // 行動版/桌面版字更大
            lineHeight: 1.1,
          }}
        >
          歡迎使用<br />
          華辰企業雲端ERP
        </Typography>
      </Box>
    </>
  );
}
